/**
 * Created by Ivan on 19.03.2026
 */

const HungryGamesRowView = function (row) {
    return Prefab.instantiate(bundles.questsgroupicon.jsons.hungry_games_row_prefab_json, { mission: row.data.mission });
};
